import { createContext, useContext } from "react";

/** Standalone auth context — import this from pages instead of App.js to avoid
 * circular chunk deps (App → lazy(UserManagement) → App). */
export const AuthContext = createContext(null);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return context;
}
